import React, { Component } from 'react';
import Firebase from 'firebase';
import 'firebase/functions';
import Moment from 'moment';
import 'moment/locale/es';
import Connector from '../../data/Connector';
import Navigation from '../../components/Navigation';
import HelperEmptyImg from '../../helper/EmptyLarge';
import { Link, withRouter } from 'react-router-dom';
import EventEmitter from '../../helper/Emitter';
import Textarea from '../../components/Form/textarea';
import { AuthUserContext, withAuthorizationMember } from '../../components/Session';

import { withTranslation } from "react-i18next";
import lang from 'i18next';



class NotesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notes: global.notes,
      current: '',
      value: '',
      showOverlay: false,
      hidden: 'hidden',
      margin: 0,
    };
  }


  componentDidMount() {
    var arr = this.props.location.pathname.split('/')
    var id = arr[arr.length-2]
    if(id !== 'home' && id !== 'member') {
      global.uid = id
    }
    Connector.setUser()
    document.title = 'Private notes - '+global.userBusiness

    EventEmitter.subscribe('userLoaded', (event) => this.configureData())
    EventEmitter.subscribe('notesLoaded', (event) => this.configureData())
    this.configureData()
  }


  configureData() {
    this.setState({
      notes: global.notes
    })  
  }



  // Payments overlay ------------------------------------------------------------



  showOverlay(id) {
    var value = ''
    for(var note of global.notes) {
      if(note.id === id) {
        value = note.data.text
      }
    }
    this.setState({
      showOverlay: true,
      current: id,
      value: value
    })
    setTimeout(() => {
      this.setState({hidden: ''});
    }, 100);
  }


  hideOverlay() {
    this.setState({hidden: 'hidden'})
    setTimeout(() => {
      this.setState({showOverlay: false});
    }, 500);
  }


  renderOverlay() {
    if(this.state.showOverlay) {
      return (
        <div className={'overlay '+this.state.hidden}>
          <div className="box">
            <h2 className="mb-20 lft">{this.state.current === '' ? lang.t('modal:notes.title1') : lang.t('modal:notes.title2')}</h2>
            <button className="btn tertiary small close rgt" onClick={() => this.hideOverlay()}>{lang.t('modal:common.close')}</button>
            <Textarea label={'Note'} value={this.state.value} onChange={(event) => this.setState({value: event})}/>
            <div className="sv-30"></div>
            <button className="btn primary" onClick={() => this.saveNote()}>{lang.t('modal:notes.button')}</button>
          </div>
        </div>
      )
    }
  }


  saveNote() {
    this.hideOverlay()
    if(this.state.current === '') {
      Firebase.database().ref('/notes/'+global.uidUser).push({
        date: parseInt(Moment().format('X')),
        text: this.state.value
      }).then((data)=>{
        EventEmitter.dispatch('showMessage', lang.t('message:noteadded'));
      }).catch((error)=>{
        EventEmitter.dispatch('showMessageError', error.message);
      })
    } else {
      Firebase.database().ref('/notes/'+global.uidUser+'/'+this.state.current).update({
        text: this.state.value
      }).then((data)=>{
        EventEmitter.dispatch('showMessage', lang.t('message:noteupdated'));
      }).catch((error)=>{
        EventEmitter.dispatch('showMessageError', error.message);
      })
    }
  }



  // Display stuff ------------------------------------------------------------



  renderNotes() {
    if(this.state.notes.length === 0) {
      return (
        <div className="empty large pt-60 clear">
          <div className="illustration mb-30">
            <div className="img1"></div>
            <div className="img2"></div>
            <div className="img3"></div>
            <div className="img4"></div>
            {HelperEmptyImg.renderImage('documents')}
          </div>
          <div className="data">
            <h3 className="mb-20">{lang.t('empty:notes.title')}</h3>
            <p style={{whiteSpace: 'pre-wrap'}}>{lang.t('empty:notes.text')}</p>
          </div>
        </div>
      )
    } else {
      var list = this.state.notes
      list.sort((a,b) => Moment(b.data.date, 'X') - Moment(a.data.date, 'X'))
      return (
        <div className="mt-30">
          {list.map((item, index) => (
            <div className="list bare mb-10" key={item.id} onClick={() => this.showOverlay(item.id)}>
              <div className="main">
                <h4>{Moment(item.data.date, 'X').format('llll')}</h4>
                <p style={{whiteSpace: 'pre-wrap'}}>{item.data.text}</p>
              </div>
              <div className="clear"></div>
            </div>
          ))}
        </div>
      )
    }
  }


  renderBase() {
    return (
      <div className={'theme-'+global.spaceTheme}>
        <div className="content form-sidebar">
          {this.renderNotes()}
        </div>

        <div className="header">
          <div className="content">
            <Link to={'/'+global.uid+'/home'} className="back lft mr-10">
              <div className="circle"></div>
              <div className="arrow"></div>
            </Link>
            <h2 className="lft">{lang.t('overview:label.privatenotes')}</h2>
            <button className="btn tertiary rgt mt-20" onClick={() => this.showOverlay('')}>{lang.t('overview:button.addanote')}</button>
            <div className="clear"></div>
          </div>
        </div>
        <Navigation active='home' />
        {this.renderOverlay()}
      </div>
    )
  }


  render() {
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          this.renderBase()
        )}
      </AuthUserContext.Consumer>
    )
  }
}



const condition = authUser => !!authUser;
export default withTranslation(['header','auth','overview','common','modal','message'])(withRouter(withAuthorizationMember(condition)(NotesPage)));